<template>
  <div class="product-banner-area">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-7 col-md-12">
          <div class="product-banner-content">
            <div class="badge-hero mb-3" data-aos="fade-right">
              <i class="ph-sparkle"></i>
              <span>{{ product.badge }}</span>
            </div>

            <h1 data-aos="fade-right" data-aos-delay="100">
              {{ product.headline }}
              <span class="gradient-text">{{ product.highlight }}</span>
            </h1>

            <p data-aos="fade-right" data-aos-delay="200">
              {{ product.description }}
            </p>

            <div class="feature-badges mb-4" data-aos="fade-right" data-aos-delay="300">
              <div
                v-for="(item, index) in product.badges"
                :key="index"
                class="feature-badge"
              >
                <i :class="item.icon"></i>
                <span>{{ item.label }}</span>
              </div>
            </div>

            <div class="banner-cta-group" data-aos="fade-right" data-aos-delay="400">
              <a
                :href="demoUrl"
                target="_blank"
                class="btn-style-one green-color"
                rel="noopener noreferrer"
              >
                Solicitar Demonstração
                <i class="ph-caret-right"></i>
              </a>
              <a href="#modulos" class="btn-style-one outline-color">
                Ver Módulos
                <i class="ph-caret-right"></i>
              </a>
            </div>

            <div class="trust-info" data-aos="fade-right" data-aos-delay="500">
              <i class="ph-check-circle"></i>
              <span>Demonstração personalizada • Sem compromisso</span>
            </div>
          </div>
        </div>

        <div class="col-lg-5 col-md-12">
          <div class="product-stats" data-aos="fade-up">
            <div
              v-for="(stat, index) in product.stats"
              :key="index"
              class="stat-card"
            >
              <div class="stat-icon">
                <i :class="stat.icon"></i>
              </div>
              <div class="stat-content">
                <span class="stat-number">{{ stat.number }}</span>
                <span class="stat-label">{{ stat.label }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tech-background">
      <div class="grid-pattern"></div>
      <div class="gradient-orb orb-1"></div>
      <div class="gradient-orb orb-2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductBanner',
  props: {
    product: {
      type: Object,
      required: true,
    },
  },
  computed: {
    demoUrl() {
      const text = encodeURIComponent(this.product.demoText)
      return `https://wa.me/5554992302401?text=${text}`
    },
  },
}
</script>

<style scoped>
.product-banner-area {
  position: relative;
  background: linear-gradient(135deg, #0a0a1a 0%, #16213e 50%, #1a1a2e 100%);
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: 140px 0 80px;
  overflow: hidden;
}

.product-banner-content,
.product-stats {
  position: relative;
  z-index: 2;
}

.badge-hero {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(109, 93, 252, 0.15);
  border: 1px solid rgba(109, 93, 252, 0.4);
  padding: 8px 16px;
  border-radius: 25px;
  color: #C5BFFF;
  font-size: 14px;
  font-weight: 600;
}

.badge-hero i {
  font-size: 18px;
}

.product-banner-content h1 {
  font-size: 48px;
  font-weight: 800;
  color: white;
  line-height: 1.2;
  margin-bottom: 20px;
}

.gradient-text {
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.product-banner-content > p {
  font-size: 17px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.7;
  margin-bottom: 28px;
  max-width: 620px;
}

.feature-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.feature-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  padding: 10px 16px;
  border-radius: 10px;
  color: white;
  font-size: 14px;
  font-weight: 600;
}

.feature-badge i {
  color: #6D5DFC;
  font-size: 18px;
}

.banner-cta-group {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
  margin-bottom: 18px;
}

.btn-style-one {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 28px;
  border-radius: 10px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-style-one.green-color {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  color: white;
  border: 2px solid transparent;
}

.btn-style-one.green-color:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
  color: white;
}

.btn-style-one.outline-color {
  background: transparent;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.btn-style-one.outline-color:hover {
  border-color: #6D5DFC;
  color: #C5BFFF;
}

.trust-info {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
}

.trust-info i {
  color: #25D366;
  font-size: 18px;
}

.product-stats {
  display: grid;
  gap: 18px;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 18px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 24px;
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateX(-8px);
  border-color: rgba(109, 93, 252, 0.5);
  background: rgba(109, 93, 252, 0.1);
}

.stat-icon {
  width: 56px;
  height: 56px;
  border-radius: 12px;
  background: linear-gradient(135deg, #6D5DFC 0%, #4361EE 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-icon i {
  font-size: 26px;
  color: white;
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 24px;
  font-weight: 800;
  color: white;
}

.stat-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

.tech-background {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
}

.grid-pattern {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(109, 93, 252, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(109, 93, 252, 0.05) 1px, transparent 1px);
  background-size: 50px 50px;
}

.gradient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
}

.orb-1 {
  width: 400px;
  height: 400px;
  background: rgba(109, 93, 252, 0.25);
  top: -100px;
  right: -50px;
}

.orb-2 {
  width: 300px;
  height: 300px;
  background: rgba(67, 97, 238, 0.2);
  bottom: -80px;
  left: -40px;
}

@media (max-width: 991px) {
  .product-banner-content h1 {
    font-size: 36px;
  }

  .product-stats {
    margin-top: 40px;
  }
}

@media (max-width: 576px) {
  .product-banner-content h1 {
    font-size: 28px;
  }

  .banner-cta-group {
    flex-direction: column;
  }

  .btn-style-one {
    width: 100%;
    justify-content: center;
  }
}
</style>
